module.exports = __webpack_public_path__ + "img/ic-save.e2b593f0.svg";